import {gql} from "@irati/utils/gql"

/**
 * Any metadata that we don't want the client to be exposed to
 */
const fragment = gql`
  fragment internalTenantMetadata on TenantMetadata {
    comments
  }
`

export const toString = fragment.loc.source.body

export default fragment
